import { render } from "./InvoiceDocuments.vue?vue&type=template&id=213f7c35"
import script from "./InvoiceDocuments.vue?vue&type=script&lang=js"
export * from "./InvoiceDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__